import { importModule } from './import.js';

if (typeof window !== "undefined") {
  if (!window.__vpMicroAgentRegister || !window.__vpMicroAgentRegister.version || window.__vpMicroAgentRegister.version < 1) {
    window.__vpMicroAgentRegister = Object.assign(
      function(_, exports) {
        window.__vpMicroAgentRegister.module = exports;
      },
      {
        version: 1,
        import: importModule,
        module: void 0,
        pending: void 0
      }
    );
  }
}
